import { Component } from '@angular/core';

@Component({
    selector: 'post-regimen',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class PostRegimenComponent {}
